import { Observable } from 'rxjs';
import { ClinicPosition, DataSourceResponse, EmployeeClinicPosition } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class EmployeeClinicPositionService extends ApiService {
  endPoint = '/api/employeeclinicPositions';
  get strorageUrl() {
    return this.storageBaseUrl;
  }
  create(model: ClinicPosition) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicPosition) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<EmployeeClinicPosition> {
    return this.http.get<EmployeeClinicPosition>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<EmployeeClinicPosition>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  getAll(queryParams: any): Observable<DataSourceResponse<EmployeeClinicPosition>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/getAll`, { params });
  }
  getByEmployee(employeeId: string): Observable<EmployeeClinicPosition[]> {
    return this.http.get<EmployeeClinicPosition[]>(`${this.clinicsBaseURL}${this.endPoint}/employee/${employeeId}`);
  }
  getByFilter(queryParams: any): Observable<EmployeeClinicPosition[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<EmployeeClinicPosition[]>(`${this.clinicsBaseURL}${this.endPoint}/getByFilter`, { params });
  }
  getByEmployees(employeeIds: string[]): Observable<EmployeeClinicPosition[]> {
    return this.http.post<EmployeeClinicPosition[]>(`${this.clinicsBaseURL}${this.endPoint}/employees`, employeeIds);
  }

  getByPerson(personId: string): Observable<EmployeeClinicPosition[]> {
    return this.http.get<EmployeeClinicPosition[]>(`${this.clinicsBaseURL}${this.endPoint}/person/${personId}`);
  }
}
